/**
 * Lista de pares rótulo e valor, em grade responsiva.
 *
 * Substitui o `Descriptions` do antd. Usa `dl`/`dt`/`dd` de propósito: é a marcação que
 * leitor de tela anuncia como "rótulo: valor", e o inventário de hardware é lido assim.
 */

import type { ReactNode } from "react";

/** Um par da lista. */
export interface Definition {
  readonly label: string;
  readonly value: ReactNode;
}

/** Colunas da lista nas telas largas. */
type DefinitionColumns = 2 | 3 | 4;

/** Classes de cada quantidade de colunas; uma coluna no celular. */
const COLUMNS_CLASS: Readonly<Record<DefinitionColumns, string>> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-4",
};

/** Entradas da lista. */
interface DefinitionListProps {
  readonly items: readonly Definition[];
  readonly columns?: DefinitionColumns;
}

/** Pares rótulo e valor em cartões pequenos, lado a lado. */
export function DefinitionList({ items, columns = 3 }: DefinitionListProps): React.ReactElement {
  return (
    <dl className={`grid grid-cols-1 gap-3 ${COLUMNS_CLASS[columns]}`}>
      {items.map((item) => (
        <div key={item.label} className="flex flex-col gap-1 rounded-lg border border-kumo-line bg-kumo-base px-4 py-3">
          <dt className="text-xs font-medium uppercase tracking-wide text-kumo-subtle">{item.label}</dt>
          <dd className="text-sm font-medium text-kumo-strong">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
